import { render, staticRenderFns } from "./SectionGalleryYarmarka.vue?vue&type=template&id=d02d8ace"
import script from "./SectionGalleryYarmarka.vue?vue&type=script&lang=ts"
export * from "./SectionGalleryYarmarka.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports